import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';

import LoadingOverlay from "./LoadingOverlay";
export default class Tw_rto_master extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.tw_rto_master_Id,
          sortable: true,
          cell: (row) => <span>{row.tw_rto_master_Id}</span>,
        },
        { name: "Text RTO Code", selector: (row, i) => row.txt_rto_code, sortable: true, cell: (row) => <span>{row.txt_rto_code}</span>, }, { name: "Text RTO Location Code", selector: (row, i) => row.txt_rtolocation_code, sortable: true, cell: (row) => <span>{row.txt_rtolocation_code}</span>, }, { name: "Text RTO Location Name", selector: (row, i) => row.txt_rtolocation_name, sortable: true, cell: (row) => <span>{row.txt_rtolocation_name}</span>, }, { name: "Text Registration Code1", selector: (row, i) => row.txt_registration_codeOne, sortable: true, cell: (row) => <span>{row.txt_registration_codeOne}</span>, }, { name: "Text Registration Code2", selector: (row, i) => row.txt_registration_codeTwo, sortable: true, cell: (row) => <span>{row.txt_registration_codeTwo}</span>, }, { name: "Text Addressline1", selector: (row, i) => row.txt_addresslineOne, sortable: true, cell: (row) => <span>{row.txt_addresslineOne}</span>, }, { name: "Text Addressline2", selector: (row, i) => row.txt_addresslinetwo, sortable: true, cell: (row) => <span>{row.txt_addresslinetwo}</span>, }, { name: "Text Addressline3", selector: (row, i) => row.txt_addresslineThree, sortable: true, cell: (row) => <span>{row.txt_addresslineThree}</span>, }, { name: "Text Country", selector: (row, i) => row.txt_country, sortable: true, cell: (row) => <span>{row.txt_country}</span>, }, { name: "Text State", selector: (row, i) => row.txt_state, sortable: true, cell: (row) => <span>{row.txt_state}</span>, }, { name: "Text District", selector: (row, i) => row.txt_district, sortable: true, cell: (row) => <span>{row.txt_district}</span>, }, { name: "Text City", selector: (row, i) => row.txt_city, sortable: true, cell: (row) => <span>{row.txt_city}</span>, }, { name: "Number Pincode", selector: (row, i) => row.num_pincode, sortable: true, cell: (row) => <span>{row.num_pincode}</span>, }, { name: "Text Zone1", selector: (row, i) => row.txt_zoneOne, sortable: true, cell: (row) => <span>{row.txt_zoneOne}</span>, }, { name: "Text Zone2", selector: (row, i) => row.txt_zoneTwo, sortable: true, cell: (row) => <span>{row.txt_zoneTwo}</span>, }, { name: "Text Status", selector: (row, i) => row.txt_status, sortable: true, cell: (row) => <span>{row.txt_status}</span>, }, { name: "Date Start Date", selector: (row, i) => row.dat_start_date, sortable: true, cell: (row) => <span>{row.dat_start_date}</span>, }, { name: "Date End Date", selector: (row, i) => row.dat_end_date, sortable: true, cell: (row) => <span>{row.dat_end_date}</span>, }, { name: "Date Insert Date", selector: (row, i) => row.dat_insert_date, sortable: true, cell: (row) => <span>{row.dat_insert_date}</span>, }, { name: "Date Modify Date", selector: (row, i) => row.dat_modify_date, sortable: true, cell: (row) => <span>{row.dat_modify_date}</span>, }, { name: "C UID", selector: (row, i) => row.c_uid, sortable: true, cell: (row) => <span>{row.c_uid}</span>, }, { name: "C_ts", selector: (row, i) => row.c_ts, sortable: true, cell: (row) => <span>{row.c_ts}</span>, }, { name: "Last Update", selector: (row, i) => row.lastupdate, sortable: true, cell: (row) => <span>{row.lastupdate}</span>, }, { name: "u_ts", selector: (row, i) => row.u_ts, sortable: true, cell: (row) => <span>{row.u_ts}</span>, },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.Tw_rto_mastereditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      tw_rto_master_Id: "",
      txt_rto_code: '', txt_rtolocation_code: '', txt_rtolocation_name: '', txt_registration_codeOne: '', txt_registration_codeTwo: '', txt_addresslineOne: '', txt_addresslinetwo: '', txt_addresslineThree: '', txt_country: '', txt_state: '', txt_district: '', txt_city: '', num_pincode: '', txt_zoneOne: '', txt_zoneTwo: '', txt_status: '', dat_start_date: '', dat_end_date: '', dat_insert_date: '', dat_modify_date: '', c_uid: '', c_ts: '', lastupdate: '', u_ts: '',
      //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case 'mail':
      case 'email':
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case 'telephone':
      case 'phone':
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case 'number':
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;

      case 'dob_child':
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case 'dob_adult':
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case 'pan':
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case 'aadhaar':
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case 'password':
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true }
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true }
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined


    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: 'txt_rto_code', inputType: 'Text', displayName: 'Text RTO Code', validationOptions: { isRequired: false } },
      { fieldName: 'txt_rtolocation_code', inputType: 'Text', displayName: 'Text RTO Location Code', validationOptions: { isRequired: false } },
      { fieldName: 'txt_rtolocation_name', inputType: 'Text', displayName: 'Text RTO Location Name', validationOptions: { isRequired: false } },
      { fieldName: 'txt_registration_codeOne', inputType: 'Text', displayName: 'Text Registration Code1', validationOptions: { isRequired: false } },
      { fieldName: 'txt_registration_codeTwo', inputType: 'Text', displayName: 'Text Registration Code2', validationOptions: { isRequired: false } },
      { fieldName: 'txt_addresslineOne', inputType: 'Text', displayName: 'Text Addressline1', validationOptions: { isRequired: false } },
      { fieldName: 'txt_addresslinetwo', inputType: 'Text', displayName: 'Text Addressline2', validationOptions: { isRequired: false } },
      { fieldName: 'txt_addresslineThree', inputType: 'Text', displayName: 'Text Addressline3', validationOptions: { isRequired: false } },
      { fieldName: 'txt_country', inputType: 'Text', displayName: 'Text Country', validationOptions: { isRequired: false } },
      { fieldName: 'txt_state', inputType: 'Text', displayName: 'Text State', validationOptions: { isRequired: false } },
      { fieldName: 'txt_district', inputType: 'Text', displayName: 'Text District', validationOptions: { isRequired: false } },
      { fieldName: 'txt_city', inputType: 'Text', displayName: 'Text City', validationOptions: { isRequired: false } },
      { fieldName: 'num_pincode', inputType: 'Text', displayName: 'Number Pincode', validationOptions: { isRequired: false } },
      { fieldName: 'txt_zoneOne', inputType: 'Text', displayName: 'Text Zone1', validationOptions: { isRequired: false } },
      { fieldName: 'txt_zoneTwo', inputType: 'Text', displayName: 'Text Zone2', validationOptions: { isRequired: false } },
      { fieldName: 'txt_status', inputType: 'Text', displayName: 'Text Status', validationOptions: { isRequired: false } },
      { fieldName: 'dat_start_date', inputType: 'Date', displayName: 'Date Start Date', validationOptions: { isRequired: false } },
      { fieldName: 'dat_end_date', inputType: 'Date', displayName: 'Date End Date', validationOptions: { isRequired: false } },
      { fieldName: 'dat_insert_date', inputType: 'Date', displayName: 'Date Insert Date', validationOptions: { isRequired: false } },
      { fieldName: 'dat_modify_date', inputType: 'Date', displayName: 'Date Modify Date', validationOptions: { isRequired: false } },
      { fieldName: 'c_uid', inputType: 'Text', displayName: 'C UID', validationOptions: { isRequired: false } },
      { fieldName: 'c_ts', inputType: 'Text', displayName: 'C_ts', validationOptions: { isRequired: false } },
      { fieldName: 'lastupdate', inputType: 'Text', displayName: 'Last Update', validationOptions: { isRequired: false } },
      { fieldName: 'u_ts', inputType: 'Text', displayName: 'u_ts', validationOptions: { isRequired: false } }
    ];

    fieldConfigs.forEach(config => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach(config => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });

  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      txt_rto_code: '', txt_rtolocation_code: '', txt_rtolocation_name: '', txt_registration_codeOne: '', txt_registration_codeTwo: '', txt_addresslineOne: '', txt_addresslinetwo: '', txt_addresslineThree: '', txt_country: '', txt_state: '', txt_district: '', txt_city: '', num_pincode: '', txt_zoneOne: '', txt_zoneTwo: '', txt_status: '', dat_start_date: '', dat_end_date: '', dat_insert_date: '', dat_modify_date: '', c_uid: '', c_ts: '', lastupdate: '', u_ts: '',
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      txt_rto_code: '', txt_rtolocation_code: '', txt_rtolocation_name: '', txt_registration_codeOne: '', txt_registration_codeTwo: '', txt_addresslineOne: '', txt_addresslinetwo: '', txt_addresslineThree: '', txt_country: '', txt_state: '', txt_district: '', txt_city: '', num_pincode: '', txt_zoneOne: '', txt_zoneTwo: '', txt_status: '', dat_start_date: '', dat_end_date: '', dat_insert_date: '', dat_modify_date: '', c_uid: '', c_ts: '', lastupdate: '', u_ts: '',
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  Tw_rto_mastereditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      tw_rto_master_Id: row.tw_rto_master_Id,
      txt_rto_code: row.txt_rto_code, txt_rtolocation_code: row.txt_rtolocation_code, txt_rtolocation_name: row.txt_rtolocation_name, txt_registration_codeOne: row.txt_registration_codeOne, txt_registration_codeTwo: row.txt_registration_codeTwo, txt_addresslineOne: row.txt_addresslineOne, txt_addresslinetwo: row.txt_addresslinetwo, txt_addresslineThree: row.txt_addresslineThree, txt_country: row.txt_country, txt_state: row.txt_state, txt_district: row.txt_district, txt_city: row.txt_city, num_pincode: row.num_pincode, txt_zoneOne: row.txt_zoneOne, txt_zoneTwo: row.txt_zoneTwo, txt_status: row.txt_status, dat_start_date: row.dat_start_date, dat_end_date: row.dat_end_date, dat_insert_date: row.dat_insert_date, dat_modify_date: row.dat_modify_date, c_uid: row.c_uid, c_ts: row.c_ts, lastupdate: row.lastupdate, u_ts: row.u_ts,
      //***editstate
      errors: {},
      touched: {}
    });
  }

  Tw_rto_masterfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + 'C_Tw_rto_master/list', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  }

  Tw_rto_mastersubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('txt_rto_code', this.state.txt_rto_code);
    formData.append('txt_rtolocation_code', this.state.txt_rtolocation_code);
    formData.append('txt_rtolocation_name', this.state.txt_rtolocation_name);
    formData.append('txt_registration_codeOne', this.state.txt_registration_codeOne);
    formData.append('txt_registration_codeTwo', this.state.txt_registration_codeTwo);
    formData.append('txt_addresslineOne', this.state.txt_addresslineOne);
    formData.append('txt_addresslinetwo', this.state.txt_addresslinetwo);
    formData.append('txt_addresslineThree', this.state.txt_addresslineThree);
    formData.append('txt_country', this.state.txt_country);
    formData.append('txt_state', this.state.txt_state);
    formData.append('txt_district', this.state.txt_district);
    formData.append('txt_city', this.state.txt_city);
    formData.append('num_pincode', this.state.num_pincode);
    formData.append('txt_zoneOne', this.state.txt_zoneOne);
    formData.append('txt_zoneTwo', this.state.txt_zoneTwo);
    formData.append('txt_status', this.state.txt_status);
    formData.append('dat_start_date', this.state.dat_start_date);
    formData.append('dat_end_date', this.state.dat_end_date);
    formData.append('dat_insert_date', this.state.dat_insert_date);
    formData.append('dat_modify_date', this.state.dat_modify_date);
    formData.append('c_uid', this.state.c_uid);
    formData.append('c_ts', this.state.c_ts);
    formData.append('lastupdate', this.state.lastupdate);
    formData.append('u_ts', this.state.u_ts);

    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Tw_rto_master/add', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Tw_rto_masterfetchHandler();
          this.handleOffcanvasClose();
          this.setState({ txt_rto_code: '', txt_rtolocation_code: '', txt_rtolocation_name: '', txt_registration_codeOne: '', txt_registration_codeTwo: '', txt_addresslineOne: '', txt_addresslinetwo: '', txt_addresslineThree: '', txt_country: '', txt_state: '', txt_district: '', txt_city: '', num_pincode: '', txt_zoneOne: '', txt_zoneTwo: '', txt_status: '', dat_start_date: '', dat_end_date: '', dat_insert_date: '', dat_modify_date: '', c_uid: '', c_ts: '', lastupdate: '', u_ts: '', });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  }

  Tw_rto_masterupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("tw_rto_master_Id", this.state.tw_rto_master_Id);
    formData.append('txt_rto_code', this.state.txt_rto_code);
    formData.append('txt_rtolocation_code', this.state.txt_rtolocation_code);
    formData.append('txt_rtolocation_name', this.state.txt_rtolocation_name);
    formData.append('txt_registration_codeOne', this.state.txt_registration_codeOne);
    formData.append('txt_registration_codeTwo', this.state.txt_registration_codeTwo);
    formData.append('txt_addresslineOne', this.state.txt_addresslineOne);
    formData.append('txt_addresslinetwo', this.state.txt_addresslinetwo);
    formData.append('txt_addresslineThree', this.state.txt_addresslineThree);
    formData.append('txt_country', this.state.txt_country);
    formData.append('txt_state', this.state.txt_state);
    formData.append('txt_district', this.state.txt_district);
    formData.append('txt_city', this.state.txt_city);
    formData.append('num_pincode', this.state.num_pincode);
    formData.append('txt_zoneOne', this.state.txt_zoneOne);
    formData.append('txt_zoneTwo', this.state.txt_zoneTwo);
    formData.append('txt_status', this.state.txt_status);
    formData.append('dat_start_date', this.state.dat_start_date);
    formData.append('dat_end_date', this.state.dat_end_date);
    formData.append('dat_insert_date', this.state.dat_insert_date);
    formData.append('dat_modify_date', this.state.dat_modify_date);
    formData.append('c_uid', this.state.c_uid);
    formData.append('c_ts', this.state.c_ts);
    formData.append('lastupdate', this.state.lastupdate);
    formData.append('u_ts', this.state.u_ts);

    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Tw_rto_master/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Tw_rto_masterfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  }

  componentDidMount() {
    this.Tw_rto_masterfetchHandler();

    //***componentDidMount
  }

  handletxt_rto_codeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_rto_code: fieldValue });
  }; handletxt_rtolocation_codeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_rtolocation_code: fieldValue });
  }; handletxt_rtolocation_nameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_rtolocation_name: fieldValue });
  }; handletxt_registration_codeOneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_registration_codeOne: fieldValue });
  }; handletxt_registration_codeTwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_registration_codeTwo: fieldValue });
  }; handletxt_addresslineOneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_addresslineOne: fieldValue });
  }; handletxt_addresslinetwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_addresslinetwo: fieldValue });
  }; handletxt_addresslineThreeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_addresslineThree: fieldValue });
  }; handletxt_countryChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_country: fieldValue });
  }; handletxt_stateChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_state: fieldValue });
  }; handletxt_districtChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_district: fieldValue });
  }; handletxt_cityChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_city: fieldValue });
  }; handlenum_pincodeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ num_pincode: fieldValue });
  }; handletxt_zoneOneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_zoneOne: fieldValue });
  }; handletxt_zoneTwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_zoneTwo: fieldValue });
  }; handletxt_statusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ txt_status: fieldValue });
  }; handledat_start_dateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ dat_start_date: fieldValue });
  }; handledat_end_dateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ dat_end_date: fieldValue });
  }; handledat_insert_dateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ dat_insert_date: fieldValue });
  }; handledat_modify_dateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ dat_modify_date: fieldValue });
  }; handlec_uidChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ c_uid: fieldValue });
  }; handlec_tsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ c_ts: fieldValue });
  }; handlelastupdateChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ lastupdate: fieldValue });
  }; handleu_tsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ u_ts: fieldValue });
  };
  //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this tw_rto_master?`)) {
      return;
    }

    var formData = new FormData();
    formData.append('tw_rto_master_Id', row.tw_rto_master_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Tw_rto_master/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Tw_rto_masterfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case 'dob_child':
      case 'dob_adult':
      case 'date':
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case 'telephone':
      case 'phone':
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case 'mail':
      case 'email':
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case 'password':
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case 'number':
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case 'pan':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case 'aadhaar':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && <span className="text-danger">*</span>}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>TW RTO Master</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary" style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Tw_rto_master</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>

                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>Please fix the following errors:</strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(([field, error]) => (
                                    <li key={field}>{error}</li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text RTO Code</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_rto_codeChange} className="form-control" name="txt_rto_code" value={this.state.txt_rto_code} required="required" placeholder="Enter Text RTO Code" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_rto_code} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text RTO Location Code</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_rtolocation_codeChange} className="form-control" name="txt_rtolocation_code" value={this.state.txt_rtolocation_code} required="required" placeholder="Enter Text RTO Location Code" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_rtolocation_code} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text RTO Location Name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_rtolocation_nameChange} className="form-control" name="txt_rtolocation_name" value={this.state.txt_rtolocation_name} required="required" placeholder="Enter Text RTO Location Name" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_rtolocation_name} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Registration Code1</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_registration_codeOneChange} className="form-control" name="txt_registration_codeOne" value={this.state.txt_registration_codeOne} required="required" placeholder="Enter Text Registration Code1" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_registration_codeOne} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Registration Code2</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_registration_codeTwoChange} className="form-control" name="txt_registration_codeTwo" value={this.state.txt_registration_codeTwo} required="required" placeholder="Enter Text Registration Code2" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_registration_codeTwo} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Addressline1</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_addresslineOneChange} className="form-control" name="txt_addresslineOne" value={this.state.txt_addresslineOne} required="required" placeholder="Enter Text Addressline1" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_addresslineOne} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Addressline2</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_addresslinetwoChange} className="form-control" name="txt_addresslinetwo" value={this.state.txt_addresslinetwo} required="required" placeholder="Enter Text Addressline2" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_addresslinetwo} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Addressline3</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_addresslineThreeChange} className="form-control" name="txt_addresslineThree" value={this.state.txt_addresslineThree} required="required" placeholder="Enter Text Addressline3" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_addresslineThree} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Country</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_countryChange} className="form-control" name="txt_country" value={this.state.txt_country} required="required" placeholder="Enter Text Country" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_country} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text State</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_stateChange} className="form-control" name="txt_state" value={this.state.txt_state} required="required" placeholder="Enter Text State" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_state} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text District</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_districtChange} className="form-control" name="txt_district" value={this.state.txt_district} required="required" placeholder="Enter Text District" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_district} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text City</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_cityChange} className="form-control" name="txt_city" value={this.state.txt_city} required="required" placeholder="Enter Text City" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_city} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Number Pincode</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlenum_pincodeChange} className="form-control" name="num_pincode" value={this.state.num_pincode} required="required" placeholder="Enter Number Pincode" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_pincode} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Zone1</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_zoneOneChange} className="form-control" name="txt_zoneOne" value={this.state.txt_zoneOne} required="required" placeholder="Enter Text Zone1" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_zoneOne} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Zone2</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_zoneTwoChange} className="form-control" name="txt_zoneTwo" value={this.state.txt_zoneTwo} required="required" placeholder="Enter Text Zone2" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_zoneTwo} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Text Status</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletxt_statusChange} className="form-control" name="txt_status" value={this.state.txt_status} required="required" placeholder="Enter Text Status" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_status} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date Start Date</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handledat_start_dateChange} className="form-control" name="dat_start_date" value={this.state.dat_start_date} required="required" placeholder="Enter Date Start Date" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_start_date} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date End Date</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handledat_end_dateChange} className="form-control" name="dat_end_date" value={this.state.dat_end_date} required="required" placeholder="Enter Date End Date" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_end_date} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date Insert Date</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handledat_insert_dateChange} className="form-control" name="dat_insert_date" value={this.state.dat_insert_date} required="required" placeholder="Enter Date Insert Date" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_insert_date} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Date Modify Date</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="date" onChange={this.handledat_modify_dateChange} className="form-control" name="dat_modify_date" value={this.state.dat_modify_date} required="required" placeholder="Enter Date Modify Date" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_modify_date} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>C UID</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlec_uidChange} className="form-control" name="c_uid" value={this.state.c_uid} required="required" placeholder="Enter C UID" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.c_uid} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>C_ts</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlec_tsChange} className="form-control" name="c_ts" value={this.state.c_ts} required="required" placeholder="Enter C_ts" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.c_ts} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Last Update</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlelastupdateChange} className="form-control" name="lastupdate" value={this.state.lastupdate} required="required" placeholder="Enter Last Update" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.lastupdate} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>u_ts</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleu_tsChange} className="form-control" name="u_ts" value={this.state.u_ts} required="required" placeholder="Enter u_ts" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.u_ts} </div>
                                  </Row><br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.Tw_rto_mastersubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Tw_rto_master</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>

                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>Please fix the following errors:</strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text RTO Code</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_rto_codeChange} className="form-control" name="txt_rto_code" value={this.state.txt_rto_code} required="required" placeholder="Enter Text RTO Code" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_rto_code} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text RTO Location Code</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_rtolocation_codeChange} className="form-control" name="txt_rtolocation_code" value={this.state.txt_rtolocation_code} required="required" placeholder="Enter Text RTO Location Code" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_rtolocation_code} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text RTO Location Name</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_rtolocation_nameChange} className="form-control" name="txt_rtolocation_name" value={this.state.txt_rtolocation_name} required="required" placeholder="Enter Text RTO Location Name" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_rtolocation_name} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Registration Code1</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_registration_codeOneChange} className="form-control" name="txt_registration_codeOne" value={this.state.txt_registration_codeOne} required="required" placeholder="Enter Text Registration Code1" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_registration_codeOne} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Registration Code2</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_registration_codeTwoChange} className="form-control" name="txt_registration_codeTwo" value={this.state.txt_registration_codeTwo} required="required" placeholder="Enter Text Registration Code2" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_registration_codeTwo} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Addressline1</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_addresslineOneChange} className="form-control" name="txt_addresslineOne" value={this.state.txt_addresslineOne} required="required" placeholder="Enter Text Addressline1" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_addresslineOne} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Addressline2</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_addresslinetwoChange} className="form-control" name="txt_addresslinetwo" value={this.state.txt_addresslinetwo} required="required" placeholder="Enter Text Addressline2" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_addresslinetwo} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Addressline3</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_addresslineThreeChange} className="form-control" name="txt_addresslineThree" value={this.state.txt_addresslineThree} required="required" placeholder="Enter Text Addressline3" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_addresslineThree} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Country</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_countryChange} className="form-control" name="txt_country" value={this.state.txt_country} required="required" placeholder="Enter Text Country" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_country} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text State</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_stateChange} className="form-control" name="txt_state" value={this.state.txt_state} required="required" placeholder="Enter Text State" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_state} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text District</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_districtChange} className="form-control" name="txt_district" value={this.state.txt_district} required="required" placeholder="Enter Text District" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_district} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text City</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_cityChange} className="form-control" name="txt_city" value={this.state.txt_city} required="required" placeholder="Enter Text City" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_city} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Number Pincode</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlenum_pincodeChange} className="form-control" name="num_pincode" value={this.state.num_pincode} required="required" placeholder="Enter Number Pincode" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.num_pincode} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Zone1</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_zoneOneChange} className="form-control" name="txt_zoneOne" value={this.state.txt_zoneOne} required="required" placeholder="Enter Text Zone1" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_zoneOne} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Zone2</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_zoneTwoChange} className="form-control" name="txt_zoneTwo" value={this.state.txt_zoneTwo} required="required" placeholder="Enter Text Zone2" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_zoneTwo} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Text Status</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletxt_statusChange} className="form-control" name="txt_status" value={this.state.txt_status} required="required" placeholder="Enter Text Status" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.txt_status} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date Start Date</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handledat_start_dateChange} className="form-control" name="dat_start_date" value={this.state.dat_start_date} required="required" placeholder="Enter Date Start Date" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_start_date} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date End Date</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handledat_end_dateChange} className="form-control" name="dat_end_date" value={this.state.dat_end_date} required="required" placeholder="Enter Date End Date" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_end_date} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date Insert Date</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handledat_insert_dateChange} className="form-control" name="dat_insert_date" value={this.state.dat_insert_date} required="required" placeholder="Enter Date Insert Date" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_insert_date} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Date Modify Date</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="date" onChange={this.handledat_modify_dateChange} className="form-control" name="dat_modify_date" value={this.state.dat_modify_date} required="required" placeholder="Enter Date Modify Date" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dat_modify_date} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>C UID</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlec_uidChange} className="form-control" name="c_uid" value={this.state.c_uid} required="required" placeholder="Enter C UID" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.c_uid} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>C_ts</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlec_tsChange} className="form-control" name="c_ts" value={this.state.c_ts} required="required" placeholder="Enter C_ts" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.c_ts} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Last Update</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlelastupdateChange} className="form-control" name="lastupdate" value={this.state.lastupdate} required="required" placeholder="Enter Last Update" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.lastupdate} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>u_ts</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleu_tsChange} className="form-control" name="u_ts" value={this.state.u_ts} required="required" placeholder="Enter u_ts" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.u_ts} </div>
                                    </Row><br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.Tw_rto_masterupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}